import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule, DecimalPipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ClipboardModule } from 'ngx-clipboard';
import { CustomerLayoutRoutes } from './customer-layout.routing';
import { NgbModule, NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { SignaturePadModule } from '@ng-plus/signature-pad';
import { CustomerComponent } from '../../pages/eCert/customer/customer.component';
import { CertificatesComponent } from '../../pages/eCert/certificates/certificates.component';
import { UploadComponent } from '../../pages/eCert/upload/upload.component';
import { FillInComponent } from '../../pages/eCert/fill-in/fill-in.component';
import { UpdateCustomerDetailsComponent } from 'src/app/pages/eCert/update-customer-details/update-customer-details.component';
import { ComponentsModule } from 'src/app/components/components.module';

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(CustomerLayoutRoutes),
    FormsModule,
    NgbModule,
    NgbNavModule,
    ClipboardModule,
    ReactiveFormsModule,
    SignaturePadModule,
    ComponentsModule
  ],
  declarations: [
    CustomerComponent,
    CertificatesComponent,
    UploadComponent,
    FillInComponent,
    UpdateCustomerDetailsComponent
  ],
  exports: [
    
  ],
  bootstrap: [
    
  ],
  providers: [
    DecimalPipe],
  schemas: [NO_ERRORS_SCHEMA]
})

export class CustomerLayoutModule { }
